var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoginListPage)?[_c('HeaderComp')]:_vm._e(),_c('div',{staticClass:"d-flex flex-row justify-content-center"},[(!_vm.isLoginListPage)?[_c('DashboardComp')]:_vm._e(),_c('router-view',{staticClass:"flex-grow-1 full-height"})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }